<ng-container *ngFor="let button of buttons">
  <ispui-link
    *ngIf="!(isButtonHidden$(button.name) | async)"
    type="default-hover"
    (click)="handleButtonClick(button)"
  >
    {{ button.label }}
  </ispui-link>
</ng-container>
